import React from 'react';
import { GenericSimpleButton, GenericSelect, GenericOption } from 'com-gyf-webcore-userinterfacecomponents';
import GlobalHelper from '../../../Common/Helpers/GlobalHelper';

let TableRowEdit = React.createClass({

    getInitialState: function () {
        return {
            LimiteCompra: this.props.row.LimiteCompra
        };
    },

    aceptarCambios: function () {
        if (this.props.row.Valor != this.props.row.valorAnterior) {
            this.props.aceptarEdicion();
        }
        else {
            this.props.mostrarMensajeLimitesIguales();
        }
    },

    cancel: function () {
        this.props.cancelEdicionLimite(this.props.row.Id);
    },

    leaveLimite: function () {
        this.props.desaparicionLapizEdicion();
    },

    editLimite: function () {
        this.props.comienzoDeEdicion(this.props.row.Id, this.props.row.Valor);
    },

    selectCombo(event) {
        this.props.modificacionLimite(parseInt(event.target.value));
    },

    render: function () {

		let valor = this.props.row.Valor;
        let limiteCompra = this.props.data.limiteCompra;

		if (this.props.novedad !== undefined) {
			let valorNovedad = this.props.novedad.ValorNovedad;
			let valorAnterior = this.props.novedad.ValorAnterior;

			if (this.props.novedadEditado != undefined) {
				if (this.props.novedadEditado.edited) {
					valor = this.props.novedadEditado.ValorNovedad;
				}
				else {
					valor = valorNovedad;
				}
			} else {
				valor = valorNovedad;
			}
		}

		var limites = this.props.data.limiteCompra.map((limite) => {
			return (
                <GenericOption key={"LIMIT_DIST_CUENTA_" + limite.Valor + Math.random()} id={limite.Valor} description={limite.Valor} />
			)
        })
		
        valor = GlobalHelper.ConvertirNumeroMilesMillones(valor);

		let buttonNode = null;
		let draw = null;
		if (this.props.editRow == true) {
			let cuenta = this.props.data.cuentas.find(x => x.Id == this.props.data.selectedId);

			draw =
				<div className="col-md-6">
					<div className="row">
						<div className="col-md-1">
							<label className="label-secondary">$</label>
						</div>
						<div className="col-md-11 no-padding-left">
							<div className="row">
								<div className="col-md-4">

								<GenericSelect
									id="limiteCuentaDistribucionLimite"
									className="form-control default-select"
									options={limites}
									value={cuenta.Valor}
									onChange={this.selectCombo}
								/>

								</div>
								<div className="col-md-3">
									<GenericSimpleButton text="Listo" buttonClass="btn btn-cta" onClick={this.aceptarCambios} />
								</div>
								<div className="col-md-5">
									<GenericSimpleButton text="Cancelar" buttonClass="btn btn-secondary" onClick={this.cancel} />
								</div>
							</div>
						</div>
					</div>
				</div>
        }
        else {
            draw =
                <div className="col-md-6" onMouseLeave={this.leaveLimite}>
				    <div className="row">
					    <div className="col-md-1 width-0">
						    <label className="label-secondary">$</label>
					    </div>
					    <div className="col-md-4 no-padding-left">
						    <div className="container-distribution">
							    <label className="label-secondary color-azul-claro hand" onClick={this.editLimit}>{valor}</label>
							    <span onClick={this.editLimite} className="ti-pencil hand" aria-hidden="true"></span>
						    </div>
			                <div className="col-md-7"></div>
					    </div>
				    </div>
			    </div>
		}
		
		return (
			<div className="row">
				<div className="col-md-2">
				</div>
				<div className="col-md-4">
					<label className="label-primary">{this.props.row.Descripcion}</label>
                </div>
				{draw}
			</div>
		);
	}
});

export default TableRowEdit